import { ApiUrls } from "../types/ApiUrls";
const API_BASE_URL = "https://console-bff.stg.arohalabs.dev";

export const apiUrls: ApiUrls = {
  prompts: {
    create: `${API_BASE_URL}/v1/prompts/`,
    addVersion: `${API_BASE_URL}/v1/prompts/version`,
    getVersion: (author: string, prompt_name: string) =>
      `${API_BASE_URL}/v1/prompts/${author}/${prompt_name}`,
    allVersions: (id: string) => `${API_BASE_URL}/v1/prompts/${id}/versions`,
    byAuthor: (author: string) => `${API_BASE_URL}/v1/prompts/${author}`,
  },
  flows: {
    execute: (author: string, flow_name: string) =>
      `${API_BASE_URL}/v1/flows/flows/${author}/${flow_name}`,
    get: (author: string, flow_name: string) =>
      `${API_BASE_URL}/v1/flows/flows/${author}/${flow_name}`,
    byAuthor: (author: string) => `${API_BASE_URL}/v1/flows/flows/${author}`,
    deploy: (author: string, flow_name: string) =>
      `${API_BASE_URL}/v1/flows/deploy/${author}/${flow_name}`,
    run: `${API_BASE_URL}/v1/flows/flows/run`,
  },
  knowledge: {
    upload: `${API_BASE_URL}/v1/knowledge/upload`,
    context: (author: string, name: string) =>
      `${API_BASE_URL}/v1/knowledge/${author}/${name}`,
  },
};
